<template>
    <div class="content__diary">
        <h1 class="content__diary__heading">Stilledagbok</h1>
        <div class="content__diary__add" v-on:click="add();">
            <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"></path>
            </svg>
            <span>Skriv ny</span>
        </div>
        <div class="content__diary__entries">
            <div
                v-for="(entry, index) in diary"
                v-bind:key="index"
                v-bind:class="cssDiaryEntryClass()"
                v-on:click="edit(entry)">
                <div class="content__diary__entry__note">{{ entry.note }} </div>
                <div class="content__diary__entry__date">{{ entry.date|formatDate }} </div>
            </div> 
        </div>        
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import moment from 'moment'

    export default {
        name: 'Diary',
        data: function () {
            return {
            }
        },
        computed: mapState([
            'diary',
            'color'
        ]),
        filters: {
            formatDate: function (value) {
                var now = moment();
                var date = moment(value);
                var diff = now.valueOf() - date.valueOf();
                if(diff < (86400000 * 2)) { // 1000*60*60*2 * 2
                    return date.calendar();
                }
                else {
                    return date.format("DD.MM.YY HH:mm");
                }
            }
        },
        created() {
            moment.locale('nb');
        },
        methods: {
            ...mapActions([
                'setBack']),
            add() {
                this.$router.push({ name: 'diraryform' });
            },
            edit(entry) {
                window.console.log(entry);
                this.$router.push({ name: 'diraryform', params: { 'entry': entry } });
            },
            cssDiaryEntryClass() {
                let classes = { 'content__diary__entry' : true };
                if(this.color) {
                    classes['bg-color'] = true;
                    classes['bg-color-' + this.color] = true;
                }
                return classes;
            },
        }
    };
</script>
<style lang="scss">
    .content__diary {
        width:100%;

        &__heading {
            padding:50px 0 20px 0;
            margin-bottom:20px;
            text-align: center;
            font-size: 26px;
            color:#a90e00;
        }

        &__add {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height:120px;
            width:120px;
            margin:0 auto 30px auto;
            padding:20px;

            background-color: #eccf95;
            border: 6px solid #fff;
            border-radius: 100%;

            color:#fff;
            cursor: pointer;

            svg {
                width:100%;
                height:100%;
            }

            span {
                font-size: 16px;
                margin-top:5px;
            }
        }

        &__entries {
            display:flex;
            flex-direction: column;
            align-items: center;

            width: 100%;
            max-width: 960px;
            margin:0 auto;
        }

        &__entry {
            width:100%;
            margin-bottom:15px;
            padding:10px;
            cursor:pointer;

            &__note {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                font-size:17px;
            }

            &__date {
                font-size:14px;
            }
        }

    }
</style>